module.exports = __webpack_public_path__ + "static/media/fullDay.6fad5467.png";